import React, { useState } from "react";
import VideoManager from "./VideoManager";

const MediaCorner = () => {
  const [activeMedia, setActiveMedia] = useState("video");
  const [hoveredTab, setHoveredTab] = useState(null);

  const tabStyle = (active, hovered) => ({
    padding: "10px 18px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "15px",
    background:
      active || hovered
        ? "#d2202a"
        : "#f1f1f1",
    color:
      active || hovered
        ? "#fff"
        : "#333",
    transition: "all 0.2s ease",
    transform: hovered
      ? "translateY(-2px)"
      : "translateY(0)",
    boxShadow: hovered
      ? "0 3px 8px rgba(210,32,42,0.25)"
      : "none",
  });

  return (
    <div>
      {/* =================================
          MAIN HEADING
      ================================= */}
      <h3
        style={{
          margin: 0,
          marginBottom: "20px",
          borderBottom: "2px solid #d2202a",
          paddingBottom: "10px",
          fontSize: "24px",
          color: "#222",
        }}
      >
        Media Corner
      </h3>

      {/* =================================
          MEDIA TABS
      ================================= */}
      <div
        style={{
          display: "flex",
          gap: "8px",
          marginBottom: "25px",
          borderBottom: "1px solid #eee",
          paddingBottom: "15px",
        }}
      >
        {/* VIDEO */}
        <button
          type="button"
          onClick={() => setActiveMedia("video")}
          onMouseEnter={() =>
            setHoveredTab("video")
          }
          onMouseLeave={() =>
            setHoveredTab(null)
          }
          style={tabStyle(
            activeMedia === "video",
            hoveredTab === "video"
          )}
        >
          🎬 ভিডিও ম্যানেজমেন্ট
        </button>

        {/* PHOTO */}
        <button
          type="button"
          onClick={() => setActiveMedia("photo")}
          onMouseEnter={() =>
            setHoveredTab("photo")
          }
          onMouseLeave={() =>
            setHoveredTab(null)
          }
          style={tabStyle(
            activeMedia === "photo",
            hoveredTab === "photo"
          )}
        >
          📷 ফটো ম্যানেজমেন্ট
        </button>

        {/* AUDIO */}
        <button
          type="button"
          onClick={() => setActiveMedia("audio")}
          onMouseEnter={() =>
            setHoveredTab("audio")
          }
          onMouseLeave={() =>
            setHoveredTab(null)
          }
          style={tabStyle(
            activeMedia === "audio",
            hoveredTab === "audio"
          )}
        >
          🎧 অডিও ম্যানেজমেন্ট
        </button>
      </div>

      {/* =================================
          CONTENT
      ================================= */}
      {activeMedia === "video" && (
        <VideoManager />
      )}

      {activeMedia === "photo" && (
        <div
          style={{
            padding: "50px 20px",
            textAlign: "center",
            color: "#777",
            border: "1px solid #eee",
            borderRadius: "6px",
          }}
        >
          <div
            style={{
              fontSize: "40px",
              marginBottom: "10px",
            }}
          >
            📷
          </div>

          <h3
            style={{
              margin: 0,
              color: "#555",
            }}
          >
            ফটো ম্যানেজমেন্ট
          </h3>

          <p>
            এই সেকশনটি শীঘ্রই তৈরি করা হবে।
          </p>
        </div>
      )}

      {activeMedia === "audio" && (
        <div
          style={{
            padding: "50px 20px",
            textAlign: "center",
            color: "#777",
            border: "1px solid #eee",
            borderRadius: "6px",
          }}
        >
          <div
            style={{
              fontSize: "40px",
              marginBottom: "10px",
            }}
          >
            🎧
          </div>

          <h3
            style={{
              margin: 0,
              color: "#555",
            }}
          >
            অডিও ম্যানেজমেন্ট
          </h3>

          <p>
            এই সেকশনটি শীঘ্রই তৈরি করা হবে।
          </p>
        </div>
      )}
    </div>
  );
};

export default MediaCorner;